// src/components/Blocks/CardList/Data.jsx
import React from 'react';
import { BlockDataForm } from '@plone/volto/components';
import Schema from './schema';
import { injectIntl } from 'react-intl';

const CardListData = (props) => {
  const { data, block, onChangeBlock, blocksConfig, intl } = props;
  const schema = Schema({ ...props, intl });

  // Migrazione dei dati esistenti e fallback
  const migratedData = {
    ...data,
    showDots: data.showDots === true ? 'yes' : data.showDots === false ? 'no' : data.showDots || 'no',
    totalResults: data.totalResults || 10,
    resultsPerPage: data.resultsPerPage || 4,
  };

  // Funzione per normalizzare gli errori
  const normalizeErrors = (errors) => {
    if (!errors) return {};
    const normalized = {};
    Object.keys(errors).forEach((key) => {
      const error = errors[key];
      normalized[key] = Array.isArray(error) ? error : [error?.message || String(error)];
    });
    return normalized;
  };

  return (
    <>
      <p>Configura il blocco Card List</p>
      <BlockDataForm
        schema={schema}
        title="Card List Settings"
        onChangeField={(id, value) => {
          onChangeBlock(block, {
            ...data,
            [id]: value,
          });
        }}
        onChangeBlock={onChangeBlock}
        formData={migratedData}
        block={block}
        blocksConfig={blocksConfig}
        errors={normalizeErrors(props.errors)} // Normalizza gli errori
      />
    </>
  );
};

export default injectIntl(CardListData);